/* eslint-disable jsx-a11y/alt-text */
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { ErrorMessage, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useAuth } from "../../contexts/AuthContext";
import "./index.css";
import { MdDelete } from "react-icons/md";
import { Card } from "react-bootstrap";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

const defaultLensSettingValue = {
  fullname: "",
  mobile: "",
  pincode: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  // area: "",
  deliveryNotes: "",
  paymentMethod: "COD",
};

const Checkout = () => {
  const { setStep, address, setAddress, hideAddress, setHideAddress } =
    useAuth();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const lastFetchedPincodeRef = useRef("");

  const location = useLocation();
  useEffect(() => {
    if (location?.state?.showAddressForm) {
      setHideAddress(false);
    }
  }, [location, setHideAddress]);

  const handleAddress = (values) => {
    setAddress(values);
    setHideAddress(true);
    setStep(2);
    navigate("/cart");
  };

  const [initialValues, setInitialValues] = useState({
    ...defaultLensSettingValue,
    ...address,
  });

  useEffect(() => {
    setInitialValues({ ...defaultLensSettingValue, ...address });
  }, [address]);

  // useEffect(() => {
  //   if (
  //     address?.pincode &&
  //     address.pincode.length === 6 &&
  //     formikRef.current &&
  //     lastFetchedPincodeRef.current !== address.pincode
  //   ) {
  //     lastFetchedPincodeRef.current = address.pincode;

  //     fetchAddressFromPincode(
  //       address.pincode,
  //       formikRef.current.setFieldValue,
  //       address.area
  //     );
  //   }
  // }, [address?.pincode, address?.area]);


  useEffect(() => {
    if (address?.area) {
      setAreaList((prev) => {
        if (prev.length === 0) {
          return [address.area];
        }
        return prev;
      });
    }
  }, [address?.area]);

  useEffect(() => {
    if (hideAddress) window.scrollTo(0, 0);
  }, [hideAddress]);

  const phoneRegExp = /^[0-9]{10}$/;

  const validationSchema = Yup.object().shape({
    fullname: Yup.string()
      .matches(
        /^(?![0-9]*$)[A-Za-z\s]+$/,
        "Full Name must only contain letters and cannot be numbers"
      )
      .required("Full Name is required"),
    mobile: Yup.string()
      .matches(phoneRegExp, "Mobile No is not valid")
      .required("Mobile No is required")
      .min(10),
    pincode: Yup.string()
      .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
      .required("Pincode is required"),
    address1: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
  });

  const {
    cartProducts,
    handleSetCartProducts,
    selectedProduct,
    handleSelectProduct,
    setSelectedProduct,
    totalExtraDiscount,
    totalPrice,
    totalDiscount,
    totalMRP,
  } = useAuth();

  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttarakhand",
    "Uttar Pradesh",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Lakshadweep",
    "Puducherry",
  ];

  const isLargeScreen =
    typeof window !== "undefined" ? window.innerWidth >= 992 : true;

  const [openDropdown, setOpenDropdown] = useState(false);

  // ===== Pincode API state =====
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [pincodeApiError, setPincodeApiError] = useState("");

  const [areaList, setAreaList] = useState([]);
  const [areaLoading, setAreaLoading] = useState(false);
  const [areaError, setAreaError] = useState("");

  // ====== Fetch city/state from pincode ======
  // const fetchAddressFromPincode = async (
  //   pincode,
  //   setFieldValue,
  //   existingArea
  // ) => {
  //   if (!pincode || String(pincode).length !== 6) return;

  //   try {
  //     setPincodeLoading(true);
  //     setAreaLoading(true);
  //     setAreaError("");
  //     setPincodeApiError("");
  //     setAreaList([]);

  //     const res = await fetch(
  //       `https://api.postalpincode.in/pincode/${pincode}`
  //     );
  //     const data = await res.json();
  //     const info = data?.[0];

  //     if (
  //       info?.Status === "Success" &&
  //       Array.isArray(info.PostOffice) &&
  //       info.PostOffice.length
  //     ) {
  //       const po = info.PostOffice[0];

  //       setFieldValue("city", po.District || "");
  //       setFieldValue("state", po.State || "");

  //       const areas = info.PostOffice.map((a) => a.Name);
  //       setAreaList(areas);

  //       if (areas.length > 0) {
  //         if (existingArea && areas.includes(existingArea)) {
  //           setFieldValue("area", existingArea);
  //         } else {
  //           setFieldValue("area", areas[0]);
  //         }
  //       }

  //       setAreaError("");
  //       setPincodeApiError("");
  //     } else {
  //       setFieldValue("city", "");
  //       setFieldValue("state", "");
  //       setFieldValue("area", "");
  //       setAreaList([]);
  //       setPincodeApiError("Invalid pincode. Please check.");
  //       setAreaError("");
  //     }
  //   } catch (err) {
  //     setFieldValue("city", "");
  //     setFieldValue("state", "");
  //     setFieldValue("area", "");
  //     setAreaList([]);
  //     setPincodeApiError("Something went wrong while checking pincode.");
  //     setAreaError("");
  //   } finally {
  //     setPincodeLoading(false);
  //     setAreaLoading(false);
  //   }
  // };

  const fetchAddressFromPincode = async (
    pincode,
    setFieldValue,
    existingArea,
  ) => {
    if (!pincode || String(pincode).length !== 6) return;

    try {
      setPincodeLoading(true);
      setAreaLoading(true);
      setAreaError("");
      setPincodeApiError("");
      setAreaList([]);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/pincode/${pincode}`);
      const data = await res.json();

      if (data?.success && Array.isArray(data.results) && data.results.length) {
        const po = data.results[0];
        const state = po.state
          .toLowerCase()
          .replace(/\b\w/g, (c) => c.toUpperCase());
        setFieldValue("city", po.district || "");
        setFieldValue("state", state || "");

        // Remove previously set validation errors
        formikRef.current.setFieldTouched("city", false);
        formikRef.current.setFieldTouched("state", false);
        formikRef.current.setFieldTouched("area", false);

        // Remove errors from Formik error object
        formikRef.current.setErrors({
          ...formikRef.current.errors,
          city: "",
          state: "",
          area: "",
        });

        const areas = data.results.map((a) =>
          a.office_name
            .replace(/\s+[BSHG]\.?O\.?(?:\s*\([^)]*\))?$/i, "")
            .trim(),
        );

        setAreaList(areas);

        if (areas.length > 0) {
          if (existingArea && areas.includes(existingArea)) {
            setFieldValue("area", existingArea);
          } else {
            setFieldValue("area", areas[0]);
          }
        }

        setAreaError("");
        setPincodeApiError("");
      } else {
        setFieldValue("city", "");
        setFieldValue("state", "");
        setFieldValue("area", "");
        setAreaList([]);
        setPincodeApiError("Invalid pincode. Please check.");
        setAreaError("");
      }
    } catch (err) {
      setFieldValue("city", "");
      setFieldValue("state", "");
      setFieldValue("area", "");
      setAreaList([]);
      setPincodeApiError("Something went wrong while checking pincode.");
      setAreaError("");
    } finally {
      setPincodeLoading(false);
      setAreaLoading(false);
    }
  };

  // ================= Qty handlers =================
  const handleDecrement = (selectItem, quantity) => {
    if (quantity < 1) return;
    updateCartProduct(selectItem, quantity);
  };

  const handleIncrement = (selectItem, quantity) => {
    updateCartProduct(selectItem, quantity);
  };

  const updateCartProduct = (selectItem, quantity) => {
    const updatedProduct = { ...selectItem, quantity };

    const updatedCart = cartProducts.map((it) =>
      it._id === updatedProduct._id ? updatedProduct : it
    );
    handleSetCartProducts(updatedCart);

    setSelectedProduct((prev = []) =>
      prev.map((p) => (p._id === updatedProduct._id ? updatedProduct : p))
    );
  };

  return (
    <Container
      className="p-0 pt-3 pb-3 position-relative d-flex flex-column justify-content-between"
      style={{ background: "" }}
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleAddress}
        innerRef={formikRef}
      >
        {({ values, getFieldProps, setFieldValue, errors }) => {
          return (
            <Form>
              <Row className="g-2 ms-0 me-0">
                {/* ---------- Contact Details ---------- */}
                <h6
                  className="card-title px-4 text-start fw-semibold"
                  style={{
                    background: "transparent",
                    fontSize: "18px",
                  }}
                >
                  CONTACT DETAILS
                </h6>
                <div className="bg-white px-4 py-3">
                  <Col md className="mb-2">
                    <TextField
                      id="fullname"
                      fullWidth
                      type="text"
                      label="Full Name"
                      name="fullname"
                      placeholder="Please Enter FullName"
                      variant="outlined"
                      {...getFieldProps("fullname")}
                      onChange={(e) => {
                        const capitalizedValue = e.target.value
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ");
                        setFieldValue("fullname", capitalizedValue);
                      }}
                    />
                    <ErrorMessage
                      component="span"
                      name={"fullname"}
                      className={`text-danger`}
                    />
                  </Col>

                  <Col md className="mb-2">
                    <TextField
                      id="mobile"
                      fullWidth
                      type="number"
                      label="Mobile"
                      name="mobile"
                      placeholder="Please Enter Mobile Number!"
                      variant="outlined"
                      inputProps={{
                        onInput: (e) => {
                          e.target.value = e.target.value.slice(0, 10);
                        },
                      }}
                      {...getFieldProps("mobile")}
                    />
                    <ErrorMessage
                      component="span"
                      name={"mobile"}
                      className={`text-danger`}
                    />
                  </Col>

                  <Col md className="mb-2">
                    <TextField
                      id="pincode"
                      type="number"
                      fullWidth
                      label="Pincode"
                      name="pincode"
                      placeholder="Please Enter Pincode!"
                      variant="outlined"
                      value={values.pincode}
                      onChange={(e) => {
                        let v = e.target.value.replace(/\D/g, "").slice(0, 6);

                        setFieldValue("pincode", v);
                        setPincodeApiError("");
                        setAreaError("");

                        if (v.length < 6) {
                          lastFetchedPincodeRef.current = "";
                          setFieldValue("city", "");
                          setFieldValue("state", "");
                          setFieldValue("area", "");
                          setAreaList([]);
                          return;
                        }

                        if (
                          v.length === 6 &&
                          lastFetchedPincodeRef.current !== v
                        ) {
                          lastFetchedPincodeRef.current = v;
                          fetchAddressFromPincode(
                            v,
                            setFieldValue,
                            values.area
                          );
                        }
                      }}
                    />

                    <ErrorMessage
                      component="span"
                      name={"pincode"}
                      className={`text-danger`}
                    />

                    {pincodeApiError && (
                      <div style={{ fontSize: 12, color: "red" }}>
                        {pincodeApiError}
                      </div>
                    )}
                  </Col>
                </div>

                {/* ---------- Address ---------- */}
                <h6
                  className="card-title px-4 text-start fw-semibold"
                  style={{ fontSize: "18px" }}
                >
                  ADDRESS
                </h6>
                <div className="bg-white px-4 py-3">
                  <Col md className="mb-3">
                    <TextField
                      id="address1"
                      type="text"
                      fullWidth
                      label="Address (House No, Building, Street, Area)"
                      name="address1"
                      placeholder="Please Enter Address"
                      variant="outlined"
                      {...getFieldProps("address1")}
                    />
                    <ErrorMessage
                      component="span"
                      name={"address1"}
                      className={`text-danger`}
                    />
                  </Col>

                  {/*  AREA DROPDOWN */}
                  {values.pincode.length === 6 && (
                    <Col md className="mb-3">
                      <TextField
                        id="area"
                        select
                        fullWidth
                        label="Area"
                        name="area"
                        value={values.area || ""}
                        disabled={
                          values.pincode.length !== 6 ||
                          areaLoading ||
                          (areaList.length === 0 && !values.area)
                        }
                        onChange={(e) => setFieldValue("area", e.target.value)}
                      >
                        {values.pincode.length !== 6 && (
                          <MenuItem value="" disabled>
                            Enter 6-digit pincode first
                          </MenuItem>
                        )}

                        {values.area && !areaList.includes(values.area) && (
                          <MenuItem value={values.area}>{values.area}</MenuItem>
                        )}

                        {areaList.length > 0 &&
                          areaList.map((item) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                      </TextField>

                      {!pincodeApiError && !errors?.pincode && areaError && (
                        <small style={{ color: "red" }}>{areaError}</small>
                      )}

                      <ErrorMessage
                        component="span"
                        name="area"
                        className="text-danger"
                      />
                    </Col>
                  )}

                  <div className="d-flex align-items-center pe-3">
                    <Col md={6} xs={6} className="me-3">
                      <TextField
                        id="city"
                        type="text"
                        fullWidth
                        label="City"
                        name="city"
                        placeholder="Please Enter City"
                        variant="outlined"
                        value={values.city}
                        onChange={(e) => setFieldValue("city", e.target.value)}
                      />
                      <ErrorMessage
                        component="span"
                        name={"city"}
                        className={`text-danger`}
                      />
                    </Col>
                    <Col md={6} xs={6}>
                      <TextField
                        id="state"
                        select
                        label="State"
                        name="state"
                        fullWidth
                        value={values.state}
                        onChange={(e) => setFieldValue("state", e.target.value)}
                      >
                        {indianStates.map((item) => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </TextField>
                      <ErrorMessage
                        component="span"
                        name={"state"}
                        className={`text-danger`}
                      />
                    </Col>
                  </div>

                  <Col md className="my-3">
                    <TextField
                      id="deliveryNotes"
                      label="Delivery notes (optional)"
                      name="deliveryNotes"
                      multiline
                      rows={3}
                      fullWidth
                      placeholder="Delivery notes (optional)"
                      variant="outlined"
                      {...getFieldProps("deliveryNotes")}
                    />
                  </Col>
                </div>

                {/* ---------- Payment & Order Products ---------- */}
                {/* <h6
                  className="card-title px-4 text-start fw-semibold"
                  style={{ fontSize: "18px" }}
                >
                  PAYMENT METHOD
                </h6> */}
                <div className="bg-white px-4 py-3">
                  <Col md className="mb-3">
                    {process.env.REACT_APP_PAYMENT_TYPE === "cod" && (
                      <div
                        className="d-flex align-items-center justify-content-between rounded px-3 py-2 mb-3"
                        style={{
                          border: "1px solid #afababff",
                          backgroundColor: "#fff",
                        }}
                      >
                        <div className="d-flex flex-column w-100">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span
                              className="fw-medium"
                              style={{ color: "#666666" }}
                            >
                              COD
                            </span>
                            <input
                              type="radio"
                              name="paymentMethod"
                              value="COD"
                              checked={values.paymentMethod === "COD"}
                              onChange={(e) =>
                                setFieldValue("paymentMethod", e.target.value)
                              }
                              style={{
                                width: "18px",
                                height: "18px",
                                accentColor: "var(--them-color)",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ======= ORDER PRODUCTS ======= */}
                    <h6 className="card-title text-start fw-semibold mb-2">
                      Order Product
                    </h6>

                    <div
                      className="order-product-wrapper"
                      style={{ position: "relative", width: "100%" }}
                    >
                      {/* Trigger */}
                      <div
                        style={{
                          border: "1px solid #afababff",
                          borderRadius: "6px",
                          padding: "10px",
                          cursor: "pointer",
                          background: "#fff",
                          fontWeight: 400,
                          color: "#666666",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          position: "relative",
                          zIndex: 10001,
                        }}
                        onClick={() => setOpenDropdown(!openDropdown)}
                      >
                        <span>
                          {selectedProduct?.length > 0
                            ? `${selectedProduct.length} product${selectedProduct.length > 1 ? "s" : ""
                            } selected`
                            : "Order Product"}
                        </span>
                        {openDropdown ? (
                          <IoChevronUp size={18} style={{ color: "#444" }} />
                        ) : (
                          <IoChevronDown size={18} style={{ color: "#444" }} />
                        )}
                      </div>

                      {/* Dim backdrop */}
                      {openDropdown && (
                        <div
                          onClick={() => setOpenDropdown(false)}
                          style={{
                            position: "fixed",
                            inset: 0,
                            background: "rgba(0,0,0,0.15)",
                            zIndex: 10000,
                          }}
                        />
                      )}

                      {/* Dropdown */}
                      {openDropdown && (
                        <div
                          style={{
                            position: "absolute",
                            top: "calc(100% + 2px)",
                            left: 0,
                            right: 0,
                            background: "#ffffff",
                            color: "#222",
                            border: "1px solid #676767",
                            borderRadius: "8px",
                            padding: "8px 0",
                            zIndex: 10002,
                            maxHeight: "360px",
                            overflowY: "auto",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                          }}
                        >
                          {cartProducts?.map((item) => {
                            const isSelected = selectedProduct?.some(
                              (p) => p._id === item._id
                            );
                            const price = item?.discount ?? item?.price;
                            const qty = item?.quantity || 1;

                            return (
                              <div
                                key={item._id}
                                style={{
                                  display: "flex",
                                  alignItems: "stretch",
                                  background: "#ffffff",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                  borderRadius: "8px",
                                  padding: "10px",
                                  margin: "11px 15px",
                                  gap: "10px",
                                  color: "#222",
                                }}
                              >
                                {/* image */}
                                <div
                                  style={{
                                    width: 64,
                                    height: "auto",
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={item?.images?.[0]}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                </div>

                                {/* content */}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "15px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      color: "#222",
                                    }}
                                  >
                                    {item.title}
                                  </div>

                                  <Card.Text
                                    className="d-flex align-items-center mt-1 mb-1"
                                    style={{ color: "#444" }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fill="#FF3F6C"
                                        d="M7.998 4c-2.674 0-5.1 1.57-6.888 4.12a.625.625 0 000 .709c1.789 2.552 4.214 4.122 6.888 4.122 2.674 0 5.099-1.57 6.888-4.12a.629.629 0 000-.709C13.096 5.57 10.672 4 7.998 4zm.192 7.627c-1.775.12-3.241-1.45-3.13-3.357.092-1.573 1.28-2.848 2.746-2.946 1.775-.12 3.24 1.45 3.13 3.357-.095 1.57-1.283 2.845-2.746 2.946zm-.09-1.456c-.955.064-1.746-.78-1.683-1.806.05-.848.69-1.533 1.48-1.588.957-.065 1.747.78 1.684 1.806-.051.85-.693 1.536-1.48 1.588z"
                                      ></path>
                                    </svg>
                                    <span
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 700,
                                        paddingLeft: 3,
                                        color: "#282c3f",
                                      }}
                                    >
                                      {Math.floor(Math.random() * 31) + 50}
                                    </span>
                                    <span
                                      style={{
                                        color: "#94969f",
                                        fontSize: 12,
                                        paddingLeft: 3,
                                      }}
                                    >
                                      People viewing now
                                    </span>
                                  </Card.Text>

                                  <div
                                    style={{
                                      marginTop: 4,
                                      fontWeight: 800,
                                      fontSize: 16,
                                      color: "#111",
                                    }}
                                  >
                                    ₹ {Number(price).toFixed(2)}
                                  </div>

                                  {/* Qty: +/- control */}
                                  <div
                                    style={{
                                      marginTop: 6,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                    }}
                                  >
                                    <span style={{ fontSize: 13 }}>Qty:</span>

                                    <div
                                      className="toggle-amount"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 10,
                                        padding: "4px 8px",
                                        borderRadius: 6,
                                        border: `1px solid ${process.env.REACT_APP_THEAM_COLOR ||
                                          "#ddd"
                                          }`,
                                        background: "#fff",
                                        userSelect: "none",
                                      }}
                                    >
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDecrement(item, (qty || 1) - 1);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          lineHeight: 1,
                                        }}
                                        title="Decrease"
                                      >
                                        <i className="fa-solid fa-minus" />
                                      </div>

                                      <div
                                        className="amount"
                                        style={{
                                          minWidth: 20,
                                          textAlign: "center",
                                        }}
                                      >
                                        {qty}
                                      </div>

                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleIncrement(item, (qty || 1) + 1);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          lineHeight: 1,
                                        }}
                                        title="Increase"
                                      >
                                        <i className="fa-solid fa-plus" />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  onClick={() => {
                                    const next = cartProducts.filter(
                                      (p) => p._id !== item._id
                                    );
                                    handleSetCartProducts(next);
                                    setSelectedProduct((prev = []) =>
                                      prev.filter((p) => p._id !== item._id)
                                    );
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  title="Remove from cart"
                                >
                                  <MdDelete size={22} color="red" />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </Col>
                </div>

                {/* ---------- Price Details ---------- */}
                <Col className="px-4">
                  {cartProducts?.length > 0 && (
                    <div>
                      <h6 className="card-title text-start fw-bold border-bottom pb-2">{`PRICE DETAILS (${selectedProduct?.length === 1
                        ? "1 Item"
                        : `${selectedProduct?.length} Items`
                        })`}</h6>
                      <div className="mt-3">
                        <div className="d-flex flex-row justify-content-between align-items-center ">
                          <span>Total MRP</span>
                          <span className="ms-2">
                            <span>
                              <span className="">₹</span>
                              {totalMRP}
                            </span>
                          </span>
                        </div>
                        {totalDiscount ? (
                          <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                            <span>Discount on MRP</span>
                            <span className="ms-2 text-success">
                              <span>
                                - <span className="">₹</span>
                                {totalDiscount}
                              </span>
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                        {totalExtraDiscount ? (
                          <>
                            <div className="d-flex flex-row justify-content-between align-items-center mt-2 border-top pt-2">
                              <span>Total Price</span>
                              <span className="ms-2">
                                <span>
                                  <span className="">₹</span>
                                  {totalMRP - totalDiscount}
                                </span>
                              </span>
                            </div>
                            <div className="d-flex flex-row justify-content-between align-items-center mt-2 ">
                              <span>Coupon Applied (Buy 2 Get 1 free)</span>
                              <span className="ms-2 text-success">
                                <span>
                                  -<span className="">₹</span>
                                  {totalExtraDiscount}
                                </span>
                              </span>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        <div className="d-flex flex-row justify-content-between align-items-center mt-2 fw-bold border-top pt-3">
                          <span>Total Amount</span>
                          <span className="ms-2">
                            <span>
                              <span className="">₹</span>
                              {totalPrice}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className="mb-2"
                    style={{
                      backgroundColor: "#FFE5EDC2",
                      fontSize: "12px",
                      padding: "4px 0 5px",
                      textAlign: "center",
                      fontWeight: 700,
                      color: "#282c3f",
                    }}
                  >
                    {selectedProduct?.length
                      ? `${selectedProduct?.length === 1
                        ? "1 Item"
                        : `${selectedProduct?.length} Items`
                      } selected for order`
                      : "No Item selected, select at least one item to place order."}
                  </div>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>

      <div className="position-sticky bottom-0 pb-3 px-4 py-2 z-2">
        <Button
          className="d-flex justify-content-center align-items-center"
          variant="dark"
          style={{
            width: "100%",
            padding: "10px",
            background: "var(--them-color)",
            borderColor: "var(--them-color)",
          }}
          onClick={() => {
            if (hideAddress) {
              setStep(2);
              navigate("/cart");
            } else {
              formikRef?.current?.submitForm();
            }
          }}
        >
          CONTINUE
        </Button>
      </div>
    </Container>
  );
};

export default Checkout;
